import React from 'react';
import { AbaBillingPlatformFragment } from '../common';
import { CONTENT_V2 } from './constants';

/**
 * /aba-billing-platform-2 — a copy-variant of /aba-billing-platform. Reuses the shared
 * `AbaBillingPlatformFragment` template (layout, dark SCSS, artwork, animations) and only
 * swaps the content via `CONTENT_V2`. Edit the copy in ./constants.js.
 */
export const AbaBillingPlatform2 = () => {
    return <AbaBillingPlatformFragment content={CONTENT_V2} />;
};
